import * as queryString from "query-string";
import http from "../httpConfig";
import { API_PATHS_NEW } from "../utils/apiConstants";
import { getAuthHeader } from "../utils/methods";

const rollTrafficNetworkResource = (payload: { nrIdOne: number; nrIdTwo: number }) => {
  const url = queryString.stringifyUrl({ url: API_PATHS_NEW.rollTrafficNetworkResource });
  return http.post(url, payload, { headers: getAuthHeader() });
};

const rollTrafficBandwidth = (payload: { bandwidthIdOne: number; bandwidthIdTwo: number }) => {
  const url = queryString.stringifyUrl({ url: API_PATHS_NEW.rollTrafficBandwidth });
  return http.post(url, payload, { headers: getAuthHeader() });
};

const getPotentialNetworkResourceRolls = (payload: { nrId: number }) => {
  const url = queryString.stringifyUrl({ url: API_PATHS_NEW.getPotentialNetworkResourceRolls, query: payload });
  return http.get(url, { headers: getAuthHeader() });
};

const RollTrafficService = {
  rollTrafficNetworkResource,
  getPotentialNetworkResourceRolls,
  rollTrafficBandwidth,
};

export default RollTrafficService;
